import { useMemo, useState } from "react";
import { DEFAULT_FORM_VALUES } from "../constants";
import { calculateStockEntryTotal } from "../utils";

export const useCashOutForm = () => {
    const [currentTab, setCurrentTab] = useState(0);

    // Common states
    const [description, setDescription] = useState("");
    const [amount, setAmount] = useState("");

    // Expense states
    const [selectedExpenseAccount, setSelectedExpenseAccount] = useState("");
    const [selectedSupplier, setSelectedSupplier] = useState("");

    // Stock Entry states
    const [selectedItems, setSelectedItems] = useState([]);
    const [itemSearchText, setItemSearchText] = useState("");
    const [isPaymentMode, setIsPaymentMode] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState("");
    const [supplierBalance, setSupplierBalance] = useState(null);
    const [fetchingPartyDetails, setFetchingPartyDetails] = useState(false);
    const [purchasePaidAmount, setPurchasePaidAmount] = useState("");

    // Employee Advance states
    const [advanceReason, setAdvanceReason] = useState("");
    const [advanceAmount, setAdvanceAmount] = useState("");
    const [selectedEmployee, setSelectedEmployee] = useState("");

    // Item creation states
    const [showCreateItemModal, setShowCreateItemModal] = useState(false);
    const [newItemData, setNewItemData] = useState(
        DEFAULT_FORM_VALUES.itemCreation
    );
    const [creatingItem, setCreatingItem] = useState(false);

    // Calculated values
    const stockEntryTotal = useMemo(() => {
        return calculateStockEntryTotal(selectedItems);
    }, [selectedItems]);

    // Form data getter for validation
    const getFormData = () => ({
        currentTab,
        description,
        amount,
        selectedExpenseAccount,
        selectedSupplier,
        selectedItems,
        stockEntryTotal,
        isPaymentMode,
        paymentAmount,
        purchasePaidAmount,
        advanceReason,
        advanceAmount,
        selectedEmployee,
    });

    // Reset form
    const resetForm = () => {
        setDescription("");
        setAmount("");
        setSelectedExpenseAccount("");
        setSelectedSupplier("");
        setSelectedItems([]);
        setItemSearchText("");
        setIsPaymentMode(false);
        setPaymentAmount("");
        setSupplierBalance(null);
        setFetchingPartyDetails(false);
        setPurchasePaidAmount("");
        setAdvanceReason("");
        setAdvanceAmount("");
        setSelectedEmployee("");
        setShowCreateItemModal(false);
        setNewItemData(DEFAULT_FORM_VALUES.itemCreation);
        setCreatingItem(false);
    };

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
        resetForm();
    };

    return {
        // Current tab
        currentTab,
        setCurrentTab,
        handleTabChange,

        // Common states
        description,
        setDescription,
        amount,
        setAmount,

        // Expense states
        selectedExpenseAccount,
        setSelectedExpenseAccount,
        selectedSupplier,
        setSelectedSupplier,

        // Purchase states
        selectedItems,
        setSelectedItems,
        itemSearchText,
        setItemSearchText,
        isPaymentMode,
        setIsPaymentMode,
        paymentAmount,
        setPaymentAmount,
        supplierBalance,
        setSupplierBalance,
        fetchingPartyDetails,
        setFetchingPartyDetails,
        purchasePaidAmount,
        setPurchasePaidAmount,
        stockEntryTotal,

        // Employee advance states
        advanceReason,
        setAdvanceReason,
        advanceAmount,
        setAdvanceAmount,
        selectedEmployee,
        setSelectedEmployee,

        // Item creation states
        showCreateItemModal,
        setShowCreateItemModal,
        newItemData,
        setNewItemData,
        creatingItem,
        setCreatingItem,

        // Utilities
        getFormData,
        resetForm,
    };
};
